import $ from 'jquery';

$(document).ready(function() {
  $('[data-fancybox]').fancybox({
    closeExisting: true,
    smallBtn: false,
    toolbar: false,
    touch: false
  });

  $('.phone_us').mask('+38 (000) 000 00 00');

  $('.btn-show-password').on('click', function(e) {
    e.preventDefault;
    var pass = $(this).siblings('.showPass');
    if (pass.attr('type') === 'password') {
      pass.attr('type', 'text');
    } else {
      pass.attr('type', 'password');
    }
  });

  $('.rem-password__label').on('click', function(f) {
    f.preventDefault;
    $(this)
      .find('.rem-password__input')
      .attr('checked');
  });

  if ($('.check-form').length > 0) {
    $.fancybox.open({
      src: '#needRegistration-window',
      closeExisting: true,
      smallBtn: false,
      toolbar: false,
      touch: false
    });
  } else {
    return;
  }
});
